import axiosInstance from '../../utils/axiosInstance';

interface Notification {
  id: number;
  title: string;
  content: string;
  notificationType: string;
  isRead: boolean;
  notificationDate: string;
  paymentDueDate?: string;
}

class NotificationService {
  private readonly baseUrl = '/api/notifications';

  async getNotificationsForCustomer(
    customerId: number
  ): Promise<Notification[]> {
    const response = await axiosInstance.get(
      `${this.baseUrl}/customer/${customerId}`
    );
    return response.data;
  }

  async getUnreadNotifications(customerId: number): Promise<Notification[]> {
    const response = await axiosInstance.get(
      `${this.baseUrl}/customer/${customerId}/unread`
    );
    return response.data;
  }

  async markAsRead(notificationId: number): Promise<Notification> {
    const response = await axiosInstance.post(
      `${this.baseUrl}/${notificationId}/read`
    );
    return response.data;
  }
}

export default new NotificationService();
